import {
  ACHIEVEMENTS_DOMAIN,
  ACHIEVEMENTS_STATE,
  DAYS_DOMAIN,
  DAYS_STATE,
  EXERCISE_FORM_CHECKS_DOMAIN,
  EXERCISE_FORM_CHECKS_STATE,
  EXERCISE_LOG_SUMMARIES_DOMAIN,
  EXERCISE_LOG_SUMMARIES_STATE,
  EXERCISES_DOMAIN,
  EXERCISES_STATE,
  EXERCISES_UI_DOMAIN,
  EXERCISES_UI_STATE,
  HIGHLIGHT_DOMAIN,
  HIGHLIGHT_STATE,
  JWT_DOMAIN,
  JWT_STATE,
  MEDIA_DOMAIN,
  MEDIA_STATE,
  PREFERENCES_DOMAIN,
  PREFERENCES_STATE,
  PROFILE_LOGS_DOMAIN,
  PROFILE_LOGS_STATE,
  PROFILES_DOMAIN,
  PROFILES_STATE,
  START_WORKOUT_DOMAIN,
  START_WORKOUT_STATE,
  WORKOUT_EXERCISES_DOMAIN,
  WORKOUT_EXERCISES_STATE,
  WORKOUT_SECTIONS_DOMAIN,
  WORKOUT_SECTIONS_STATE
} from '@gymaholic/packages'
import {
  ABOUTS_DOMAIN,
  ABOUTS_STATE
} from 'modules/abouts/constants'
import {
  ADDRESS_DOMAIN,
  ADDRESS_STATE
} from 'modules/address/constants'
import {
  APP_DOMAIN,
  APP_STATE
} from 'modules/app/constants'
import {
  ARTICLES_DOMAIN,
  ARTICLES_STATE
} from 'modules/articles/constants'
import {
  BANNER_DOMAIN,
  BANNER_STATE
} from 'modules/banner/constants'
import {
  CARDS_DOMAIN,
  CARDS_STATE
} from 'modules/cards/constants'
import {
  CART_PRODUCTS_DOMAIN,
  CART_PRODUCTS_STATE
} from 'modules/cart-products/constants'
import {
  CART_DOMAIN,
  CART_STATE
} from 'modules/cart/constants'
import {
  CATEGORIES_DOMAIN,
  CATEGORIES_STATE
} from 'modules/categories/constants'
// import { COACHES_DOMAIN, COACHES_STATE } from 'modules/coaching'
import {
  COMMENTS_DOMAIN,
  COMMENTS_STATE
} from 'modules/comments/constants'
import {
  COMPONENTS_DOMAIN,
  COMPONENTS_STATE
} from 'modules/components/constants'
import {
  CREDENTIAL_DOMAIN,
  CREDENTIAL_STATE
} from 'modules/credential/constants'
import {
  CURRENCIES_DOMAIN,
  CURRENCIES_STATE
} from 'modules/currencies/constants'
import {
  EDITING_DOMAIN,
  EDITING_STATE
} from 'modules/editing/constants'
import {
  EMAIL_TEMPLATES_DOMAIN,
  EMAIL_TEMPLATES_STATE
} from 'modules/email-templates/constants'
import {
  FEATURED_DOMAIN,
  FEATURED_STATE
} from 'modules/featured/constants'
import {
  LOGS_DOMAIN,
  LOGS_STATE
} from 'modules/logs/constants'
import {
  MENU_DOMAIN,
  MENU_STATE
} from 'modules/menu/constants'
import {
  MODAL_DOMAIN,
  MODAL_STATE
} from 'modules/modal/constants/index.cjs'
import {
  MOTIVATION_DOMAIN,
  MOTIVATION_STATE
} from 'modules/motivation/constants'
import {
  NETWORK_DOMAIN,
  NETWORK_STATE
} from 'modules/network/constants'
import {
  NOTIFICATIONS_DOMAIN,
  NOTIFICATIONS_STATE
} from 'modules/notifications/constants'
import {
  ORDER_PRODUCTS_DOMAIN,
  ORDER_PRODUCTS_STATE
} from 'modules/order-products/constants'
import {
  ORDERS_DOMAIN,
  ORDERS_STATE
} from 'modules/orders/constants/index.cjs'
import {
  PAGES_DOMAIN,
  PAGES_STATE
} from 'modules/pages/constants'
import {
  PARSER_DOMAIN,
  PARSER_STATE
} from 'modules/parser/constants'
import {
  PRODUCT_QUANTITIES_DOMAIN,
  PRODUCT_QUANTITIES_STATE
} from 'modules/product-quantities/constants'
import {
  PRODUCTS_DOMAIN,
  PRODUCTS_STATE
} from 'modules/products/constants'
import {
  PROMO_CODES_DOMAIN,
  PROMO_CODES_STATE
} from 'modules/promo-codes/constants'
import {
  REPORTS_DOMAIN,
  REPORTS_STATE
} from 'modules/reports/constants'
import {
  ROUTER_DOMAIN,
  ROUTER_STATE
} from 'modules/router/constants'
import {
  SEARCH_DOMAIN,
  SEARCH_STATE
} from 'modules/search/constants'
import {
  SECTIONS_DOMAIN,
  SECTIONS_STATE
} from 'modules/sections/constants/index.cjs'
import {
  SETTINGS_DOMAIN,
  SETTINGS_STATE
} from 'modules/settings/constants'
import {
  SHIPPING_DOMAIN,
  SHIPPING_STATE
} from 'modules/shipping/constants'
import {
  TAGS_DOMAIN,
  TAGS_STATE
} from 'modules/tags/constants'
import {
  TOKENS_DOMAIN,
  TOKENS_STATE
} from 'modules/tokens/constants'
import {
  TRAINING_APP_DOMAIN,
  TRAINING_APP_STATE
} from 'modules/training/modules/app/constants'
import {
  CHATS_DOMAIN,
  CHATS_STATE
} from 'modules/training/modules/chat/constants'
import {
  CIDS_DOMAIN,
  CIDS_STATE
} from 'modules/training/modules/cids'
import {
  CUSTOMERS_DOMAIN,
  CUSTOMERS_STATE
} from 'modules/training/modules/customer/constants'
import {
  MESSAGES_DOMAIN,
  MESSAGES_STATE
} from 'modules/training/modules/message/constants'
import {
  NETWORK_DOMAIN as TRAINING_NETWORK_DOMAIN,
  NETWORK_STATE as TRAINING_NETWORK_STATE
} from 'modules/training/modules/network/constants'
import {
  PROFILE_CREATOR_PREFERENCES_DOMAIN,
  PROFILE_CREATOR_PREFERENCES_STATE
} from 'modules/training/modules/profile-creator-preferences/constants'
import {
  REFERENCES_DOMAIN,
  REFERENCES_STATE
} from 'modules/training/modules/references/constants'
import {
  TRAINING_AUTH_DOMAIN,
  TRAINING_AUTH_STATE
} from 'modules/training/modules/app-auth/constants'
import {
  PLANS_DOMAIN,
  PLANS_STATE
} from 'modules/plan/redux/constants'
import {
  TRAINING_USERS_DOMAIN,
  TRAINING_USERS_STATE
} from 'modules/training/modules/training-users/constants'
import {
  WORKOUTS_DOMAIN,
  WORKOUTS_STATE
} from 'modules/workout/redux/constants'
import {
  USERS_DOMAIN,
  USERS_STATE
} from 'modules/users/constants'
import {
  VIEWPORT_DOMAIN,
  VIEWPORT_STATE
} from 'modules/viewport/constants'
import {
  VIEWS_DOMAIN,
  VIEWS_STATE
} from 'modules/views/constants'
import {
  SUBSCRIPTIONS_DOMAIN,
  SUBSCRIPTIONS_STATE
} from 'modules/training/modules/subscription/constants'
import {
  SUBSCRIPTION_CANCELLATION_DOMAIN_NAME,
  SUBSCRIPTION_CANCELLATION_STATE
} from 'modules/subscription-cancellation/redux/constants/index.js'
import {
  STRIPE_DOMAIN_NAME,
  STRIPE_STATE
} from 'modules/stripe/redux/constants/index.js'
import {
  HEADER_BANNER_DOMAIN,
  HEADER_BANNER_STATE
} from 'modules/headerBanner/constants/index.js'
import {
  CONSENT_DOMAIN,
  CONSENT_STATE
} from 'modules/consent/constants'

/**
 * Default state for each domain.
 * @type {Object}
 */
const REDUX_STATE = {
  [ADDRESS_DOMAIN]: ADDRESS_STATE,
  [ARTICLES_DOMAIN]: ARTICLES_STATE,
  // [COACHES_DOMAIN]: COACHES_STATE,
  [CARDS_DOMAIN]: CARDS_STATE,
  [CART_DOMAIN]: CART_STATE,
  [CART_PRODUCTS_DOMAIN]: CART_PRODUCTS_STATE,
  [CATEGORIES_DOMAIN]: CATEGORIES_STATE,
  [COMMENTS_DOMAIN]: COMMENTS_STATE,
  [COMPONENTS_DOMAIN]: COMPONENTS_STATE,
  [CREDENTIAL_DOMAIN]: CREDENTIAL_STATE,
  [CURRENCIES_DOMAIN]: CURRENCIES_STATE,
  [CUSTOMERS_DOMAIN]: CUSTOMERS_STATE,
  [SUBSCRIPTIONS_DOMAIN]: SUBSCRIPTIONS_STATE,
  [DAYS_DOMAIN]: DAYS_STATE,
  [EDITING_DOMAIN]: EDITING_STATE,
  [EMAIL_TEMPLATES_DOMAIN]: EMAIL_TEMPLATES_STATE,
  [FEATURED_DOMAIN]: FEATURED_STATE,
  [JWT_DOMAIN]: JWT_STATE,
  [LOGS_DOMAIN]: LOGS_STATE,
  [HEADER_BANNER_DOMAIN]: HEADER_BANNER_STATE,
  [MENU_DOMAIN]: MENU_STATE,
  [MODAL_DOMAIN]: MODAL_STATE,
  [MOTIVATION_DOMAIN]: MOTIVATION_STATE,
  [NETWORK_DOMAIN]: NETWORK_STATE,
  [NOTIFICATIONS_DOMAIN]: NOTIFICATIONS_STATE,
  [ORDERS_DOMAIN]: ORDERS_STATE,
  [PAGES_DOMAIN]: PAGES_STATE,
  [PARSER_DOMAIN]: PARSER_STATE,
  [PRODUCT_QUANTITIES_DOMAIN]: PRODUCT_QUANTITIES_STATE,
  [PRODUCTS_DOMAIN]: PRODUCTS_STATE,
  [PROMO_CODES_DOMAIN]: PROMO_CODES_STATE,
  [REPORTS_DOMAIN]: REPORTS_STATE,
  [SEARCH_DOMAIN]: SEARCH_STATE,
  [SECTIONS_DOMAIN]: SECTIONS_STATE,
  [SETTINGS_DOMAIN]: SETTINGS_STATE,
  [SHIPPING_DOMAIN]: SHIPPING_STATE,
  [TAGS_DOMAIN]: TAGS_STATE,
  [TOKENS_DOMAIN]: TOKENS_STATE,
  [USERS_DOMAIN]: USERS_STATE,
  [VIEWS_DOMAIN]: VIEWS_STATE,
  [APP_DOMAIN]: APP_STATE,
  [EXERCISE_FORM_CHECKS_DOMAIN]: EXERCISE_FORM_CHECKS_STATE,
  [BANNER_DOMAIN]: BANNER_STATE,
  [CIDS_DOMAIN]: CIDS_STATE,
  [ORDER_PRODUCTS_DOMAIN]: ORDER_PRODUCTS_STATE,
  [REFERENCES_DOMAIN]: REFERENCES_STATE,
  [ROUTER_DOMAIN]: ROUTER_STATE,
  [TRAINING_APP_DOMAIN]: TRAINING_APP_STATE,
  [TRAINING_AUTH_DOMAIN]: TRAINING_AUTH_STATE,
  [EXERCISES_DOMAIN]: EXERCISES_STATE,
  [REPORTS_DOMAIN]: REPORTS_STATE,
  [PLANS_DOMAIN]: PLANS_STATE,
  [PROFILES_DOMAIN]: PROFILES_STATE,
  [TRAINING_USERS_DOMAIN]: TRAINING_USERS_STATE,
  [TRAINING_NETWORK_DOMAIN]: TRAINING_NETWORK_STATE,
  [WORKOUTS_DOMAIN]: WORKOUTS_STATE,
  [EXERCISE_LOG_SUMMARIES_DOMAIN]: EXERCISE_LOG_SUMMARIES_STATE,
  [START_WORKOUT_DOMAIN]: START_WORKOUT_STATE,
  [WORKOUT_SECTIONS_DOMAIN]: WORKOUT_SECTIONS_STATE,
  [WORKOUT_EXERCISES_DOMAIN]: WORKOUT_EXERCISES_STATE,
  [VIEWPORT_DOMAIN]: VIEWPORT_STATE,
  [MEDIA_DOMAIN]: MEDIA_STATE,
  [PROFILE_LOGS_DOMAIN]: PROFILE_LOGS_STATE,
  [PREFERENCES_DOMAIN]: PREFERENCES_STATE,
  [PROFILE_CREATOR_PREFERENCES_DOMAIN]: PROFILE_CREATOR_PREFERENCES_STATE,
  [CHATS_DOMAIN]: CHATS_STATE,
  [MESSAGES_DOMAIN]: MESSAGES_STATE,
  [ACHIEVEMENTS_DOMAIN]: ACHIEVEMENTS_STATE,
  [HIGHLIGHT_DOMAIN]: HIGHLIGHT_STATE,
  [EXERCISES_UI_DOMAIN]: EXERCISES_UI_STATE,
  [ABOUTS_DOMAIN]: ABOUTS_STATE,
  [SUBSCRIPTION_CANCELLATION_DOMAIN_NAME]: SUBSCRIPTION_CANCELLATION_STATE,
  [STRIPE_DOMAIN_NAME]: STRIPE_STATE,
  [CONSENT_DOMAIN]: CONSENT_STATE
}

export {
  REDUX_STATE
}
